<template>
    <div class="row">
        <div class="col-12 col-sm-5 col-md-5 col-lg-4">
            <div class="patient-action">
                <span> Select Patient </span>
                <div class="col-lg-4">
                    <input
                        v-model="patientSerialNo"
                        name="serial"
                        type="number"
                        class="form-control"
                        placeholder="Patient Id"
                        @keyup="searchPatientById"
                    />
                </div>
                <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="openPatientAddModal"
                >
                    New Patient
                </button>
            </div>
            <div class="col-md-7 col-lg-12">
                <AsyncSelect
                    placeholder="Patient Name, ID, Mobile No"
                    v-model="patient"
                    :api-service="fetchContactProfiles"
                    :additional-query="additionalQuery"
                    :format-label="formatPatientLabel"
                />
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-1 mt-2">
            <span> Patient ID </span>
            <input
                :value="patientId"
                type="text"
                class="form-control"
                readonly
            />
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 mt-2">
            <span> Patient Phone No </span>
            <input
                :value="patientMobile && patientMobile.value"
                type="text"
                class="form-control"
                readonly
            />
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mt-2">
            <div class="col-md-5 d-flex align-items-center">
                    <span> Invoice Date </span>      
            </div>
            <div class="col-md-7 col-lg-12">
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="date"
                    placeholder=""
                    v-model="formData.date"
                >
            </div>
        </div>
    </div>
        
    <div class="row py-1">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
            <div class="col-md-5 d-flex align-items-center">
                <span> Select Admission info </span>      
            </div>
            <div class="col-md-7 col-lg-12">
                <div>
                    <v-select
                        placeholder="Select Admission Info"
                        label="text"
                        :options="registrationList"
                        v-model="formData.ipd_register_id"
                        :reduce="text => text.id"
                    />
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
            <span> Ward / Bed / Cabin </span>
            <input
                :value="selectedRegisterInfo && selectedRegisterInfo.service_resource.name"
                type="text"
                class="form-control"
                readonly
            />
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="col-md-5 d-flex align-items-center">
            <span> Select Client </span>
          </div>
          <div class="col-md-7 col-lg-12">
            <AsyncSelect
                placeholder="Select Client"
                v-model="formData.contact_profile_client_id"
                :api-service="fetchContactProfiles"
                :additional-query="{ type: 'client' }"
                :format-label="formatPatientLabel"
                :reduce="referrer => referrer.id"
            />
          </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
            <div class="col-md-5 d-flex align-items-center">
                    <span> Select Referrer </span>                 
            </div>
            <div class="col-md-7 col-lg-12">
                <AsyncSelect
                    placeholder="Select Referrer"
                    v-model="formData.referrer_id"
                    :api-service="fetchContactProfiles"
                    :additional-query="{ type: 'agent' }"
                    :format-label="formatPatientLabel"
                    :reduce="referrer => referrer.id"
                />
            </div>
        </div>

        <div class="col-12 col-sm-5 col-md-12 col-lg-4">
            <div class="col-md-2 d-flex align-items-center col-lg-12">
                <span> Consultant / Doctor </span>      
            </div>
            <div class="col-md-6 col-lg-12">
                <AsyncSelect
                    placeholder="Select consultant"
                    v-model="formData.service_resource_id"
                    :api-service="fetchServiceList"
                    :additional-query="{ resource_type: 'human_resources' }"
                    :format-label="formatPatientLabel"
                    :reduce="consultant => consultant.id"
                />
            </div>
        </div>

      <div class="col-12 col-sm-6 col-md-6 col-lg-4">
        <div class="col-md-2 d-flex align-items-center col-lg-12">
          <span> Out Doctor Name </span>
        </div>
        <div class="col-md-6 col-lg-12">
          <input
              class="form-control invoice-edit-input"
              tabindex="1"
              type="text"
              placeholder="Out Doctor Name "
              v-model="formData.transport_reference"
          >
        </div>
      </div>
    </div>
    
    <div class="row py-2">
        <div class="col-12 col-sm-5 col-md-12 col-lg-8">
            <div class="col-md-5 col-lg-12">
                <AsyncSelect
                    placeholder="Select Service"
                    v-model="productId"
                    :api-service="fetchProductBySlug"
                    :reduce="name => name.id"
                    :format-label="option => option.text"
                    :additional-query="additionalProductQuery"
                    label="text"
                    input-class="product-field"
                />
            </div>
        </div>
    </div>

    <div class="row">
        <AddPatientModal
            v-if="$store.state.isModalOpenTwo"
            :doctors="doctors"
            @onCreateProfile="onCreateProfile"
        />

        <Loader v-if="isLoader" />
    </div>

</template>

<script setup>
import { ref, onMounted, watch, inject, computed, reactive } from 'vue'
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import handleContact from '@/services/modules/contact'
import handleHospitalBilling from "@/services/modules/hospital/billing";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleInventory from "@/services/modules/inventory";
import handleHospital from '@/services/modules/hospital'
import AddPatientModal from '@/components/molecule/company/hospital/AddPatientModal'
import useDate from "@/services/utils/day";
import Loader from "@/components/atom/LoaderComponent";

const props = defineProps({
  addNewItem: {
    type: Function
  },
  products: {
    type: Array,
    default: []
  },
  tableItems: {
    type: Array
  }
})

const $route = useRoute();
const $store = useStore();
const date = useDate();
const patient = ref(null);
const userInfo = ref(null);
const isLoader = ref(false);
const patientSerialNo = ref(null);
const companyId = $route.params.companyId
const companyQuery = `?company_id=${companyId}`;
const selectedData = ref({});
const formData = inject('formData');
const showError = inject('showError')
const productId = ref(null);
const registrationList = ref([]);
const additionalQuery = {
    type: "patient"
}
const additionalProductQuery = {
    product_type: "services",
    slug: "investigation",
    with_rate: true
}
const doctors = reactive([]);

const { fetchServiceList, fetchPatientDetailsBySerial } = handleHospital()
const {fetchProductBySlug} = handlePurchase()
const {getProduct} = handleInventory()
const {fetchContactProfiles, fetchSingleContactProfile} = handleContact()
const { fetchIpdRegisterList } = handleHospitalBilling()
const { formatPatientLabel } = useAsyncDropdownHelper()

//computed
const selectedRegisterInfo = computed(() => {
    if (formData.value.ipd_register_id) {
        return registrationList.value.find(registration => registration.id === formData.value.ipd_register_id)
    }
    return null
})

const patientMobile = computed(() => {
    if (selectedData.value.profile_items && selectedData.value.profile_items.length) {
        return selectedData.value.profile_items.find(item => item.field === 'mobile_no')
    }
    return null
})

const patientId = computed(() => {
    if (
        selectedData.value.company_roles &&
        selectedData.value.company_roles.length &&
        selectedData.value.company_roles[0].pivot
    ) {
        return selectedData.value.company_roles[0].pivot.serial_no
    }
    return null
})

onMounted(() => {
    formData.value.date = date.currentDate();
})

watch(patient, () => {
    if (!patient.value) return;

    registrationList.value = [];
    const patientQuery = companyQuery + '&type=patient';
    formData.value.contact_profile_id = patient.value.id;
    const ipdQuery = companyQuery + `&contact_profile_id=${formData.value.contact_profile_id}`;

    fetchSingleContactProfile(patient.value.id, patientQuery).then(res => {
        if (res.data) {
            selectedData.value = formData.value.contact = res.data;
        }
    })

    fetchIpdRegisterList(ipdQuery).then(res => {
        if(res.data) registrationList.value = res.data
    })
})

watch(productId, async () => {
    const found = !!props.tableItems.find(item => item.product_id === productId.value);

    if (found) {
        showError('Item already selected!');
        return;
    }

    const productResp = await getProduct({
        id: productId.value,
        company_id: companyId
    })
    if (!productResp.data) {
        showError("Something went wrong please try again");
        return;
    }
    let selected = productResp.data;
    let product = {
        name: selected.name
    }
    props.tableItems.push({
        id: selected.id,
        product_id: productId.value,
        name: selected.name,
        description: selected.description.unit.description,
        quantity: 1,
        rate: selected.description.sales_price,
        discount: 0,
        vat: selected.description.vat_rate,
        sub_total: 0,
        discount_amount: 0,
        discount_percent: 0,
        vat_amount: 0,
        total: 0,
        is_edit: false,
        product: product
    })
})

const openPatientAddModal = () => {
    const query = `?company_id=${companyId}&type=doctor`
    fetchContactProfiles(query).then((res) => {
        if(res.status) doctors.push(...res.data)
    }).then(() => {
        $store.state.isModalOpenTwo = true
    })
}

const searchPatientById = async () => {

    if(!patientSerialNo.value) return;
    isLoader.value = true;
    const query = `?company_id=${companyId}`;
    userInfo.value = null
    patient.value = null
    await fetchPatientDetailsBySerial(query, patientSerialNo.value)
        .then((res) => {
            
            if (!res.status) {
                return showError(res.message)
            }

            formData.value.ipd_register_id = null
            
            userInfo.value = res.data
            patient.value = {
                id: userInfo.value.id,
                name: userInfo.value.full_name
            }
        })
    
    isLoader.value = false;
}

const onCreateProfile = (profileInfo) => {
    patient.value = profileInfo;
    patient.value.name = profileInfo.full_name
}

</script>

<style scoped>
.select label {
    font-size: 14px;
}
.h-40 {
    height: 40px;
    align-items: center;
}
.patient-action {
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>